import React from "react";
import { Layout } from "antd";
import moment from "moment";

const FooterView: React.FC = () => {
  console.log(import.meta.env)
  return (
    <Layout.Footer style={{ textAlign: "center" }}>
      © {moment().format("Y")} <span>{import.meta.env.VITE_REACT_APP_APP_NAME ?? ""}</span>
    </Layout.Footer>
  );
};

export default FooterView;
